<template>
  <div>
    <app-centered-column>
      <zmanim-navigation />
      <app-jumbotron :screenshot-caption="screenshotCaption">
        <div slot="content">
          <app-jumbotron-banner>
            <app-rotating-label
              :strings="strings"
              :random="true"
              class="rotating-label"
              static-prefix="The app "
              static-suffix="."
            />
          </app-jumbotron-banner>
          <app-call-to-action v-bind="callsToAction.jumbotron" />
        </div>
        <div slot="screenshot">
          <zmanim-list />
        </div>
      </app-jumbotron>
      <app-section-header v-if="topReview">
        Customer Approved
      </app-section-header>
      <app-review v-if="topReview" id="zmanim-app-review" v-bind="topReview" />
      <app-section-header>
        Highlights
      </app-section-header>
      <div class="zmanim-landing__features-grid">
        <app-feature-tile
          v-for="(feature, index) in features.all"
          :key="`tile-${index}`"
          v-bind="feature"
        />
      </div>
      <app-call-to-action v-bind="callsToAction.interstitialFAQDownload" />
      <app-section-header>
        Get Started with These Features
      </app-section-header>
      <app-feature-cell
        v-for="(feature, index) in features.free"
        :key="`free-${index}`"
        v-bind="feature"
      />
      <app-section-header>
        Trusted by Thousands Worldwide
      </app-section-header>
      <zmanim-map :caption="mapCaption" />
      <app-call-to-action
        v-bind="callsToAction.interstitialFAQDownloadItsFree"
      />
      <app-section-header>
        Go Even Further with Premium
      </app-section-header>
      <app-feature-cell
        v-for="(feature, index) in features.premium"
        :key="`paid-${index}`"
        v-bind="feature"
      />
      <app-call-to-action
        v-bind="callsToAction.interstitialFAQDownloadComparison"
      />
    </app-centered-column>
    <zmanim-footer />
  </div>
</template>

<script>
/**
 * write a component's description
 */
import { AppReviewFetcher } from '@/lib/itunesReviews'
import * as features from '@/lib/features'
import * as callsToAction from '@/lib/callsToAction'
import * as locations from '@/lib/locations'
import strings from '@/lib/rotatingLabel'
import { appId } from '@/config'
import { SolarPathEffect } from '@/lib/mixins'

import AppJumbotron from './AppJumbotron'
import AppJumbotronBanner from './AppJumbotronBanner'
import AppCenteredColumn from './AppCenteredColumn'
import AppSectionHeader from './AppSectionHeader'
import AppRotatingLabel from './AppRotatingLabel'
import AppFeatureTile from './AppFeatureTile'
import AppFeatureCell from './AppFeatureCell'
import AppReview from './AppReview'
import AppCallToAction from './AppCallToAction'
import ZmanimList from './ZmanimList'
import ZmanimMap from './ZmanimMap'
import ZmanimNavigation from './ZmanimNavigation'
import ZmanimFooter from './ZmanimFooter'

export default {
  name: 'LandingPage',
  components: {
    AppJumbotron,
    AppCenteredColumn,
    AppSectionHeader,
    AppFeatureTile,
    AppReview,
    AppCallToAction,
    AppFeatureCell,
    AppJumbotronBanner,
    AppRotatingLabel,
    ZmanimList,
    ZmanimMap,
    ZmanimNavigation,
    ZmanimFooter
  },
  mixins: [SolarPathEffect],
  /**
   * @description
   * @returns {any}
   */
  data () {
    return {
      fetcher: new AppReviewFetcher({ appId }),
      reviews: [],
      callsToAction,
      features,
      strings,
      locations
    }
  },
  computed: {
    /**
     * @description
     * @returns {any}
     */
    topReview () {
      const reviewCount = this.reviews.length
      const randomIndex = Math.floor(Math.random() * reviewCount)
      if (!reviewCount) {
        return undefined
      }
      const review = this.reviews[randomIndex]
      return review
    },
    /**
     * @description
     * @returns {any}
     */
    mapCaption () {
      return 'Caption Goes Here'
    },
    /**
     * @description
     * @returns {any}
     */
    screenshotCaption () {
      return locations.brooklyn.options.locationName
    }
  },
  /**
   * @description
   */
  mounted () {
    if (this.reviews.length === 0) {
      this.fetcher.fetchReviews().then(reviews => {
        this.reviews = reviews
      })
    }
  }
}
</script>

<style scoped>
@media screen and (min-width: 960px) {
  .zmanim-landing__features-grid {
    padding: 0;
    margin: 0;
  }
}

@media screen and (max-width: 960px) {
  .zmanim-landing__features-grid {
    margin: 0 0.5rem;
  }
}

.zmanim-landing__features-grid {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
}

.rotating-label {
  color: #ff8511;
}
</style>
